import { Chip } from '@bp/ui-components';
import { SubmissionStatus } from 'client/gql/graphql';
import { getSubmissionStatusColor, getSubmissionStatusTranslation } from 'components/Submissions/utils/submissionUtils';
import { useTranslation } from 'react-i18next';

type StatusChipProps = {
  status: SubmissionStatus | 'delayed';
  isEditorOfCourse?: boolean;
  className?: string | undefined;
};

export const StatusChip = ({ status, className, isEditorOfCourse }: StatusChipProps) => {
  const { t } = useTranslation();

  const text =
    status === 'delayed'
      ? t('submissions.delayable')
      : getSubmissionStatusTranslation(status, isEditorOfCourse ? 'teacher' : 'student');

  const color = getSubmissionStatusColor(status);

  return <Chip value={text} bgColor={color} className={className} />;
};
